var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 9.61068L18.9402 16.6523C19.1797 16.8918 19.4631 17.0076 19.7905 16.9996C20.1178 16.9916 20.4012 16.8679 20.6407 16.6284C20.8802 16.3889 21 16.1054 21 15.7781C21 15.4508 20.8802 15.1673 20.6407 14.9278L13.2638 7.57483C13.0722 7.38322 12.8566 7.23951 12.6171 7.14371C12.3776 7.0479 12.1381 7 11.8986 7C11.659 7 11.4195 7.0479 11.18 7.14371C10.9405 7.23951 10.7249 7.38322 10.5333 7.57483L3.15638 14.9518C2.91687 15.1913 2.8011 15.4707 2.80909 15.7901C2.81707 16.1094 2.94082 16.3889 3.18033 16.6284C3.41984 16.8679 3.70326 16.9876 4.0306 16.9876C4.35793 16.9876 4.64135 16.8679 4.88086 16.6284L11.8986 9.61068Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpM);
export default __webpack_public_path__ + "static/media/arrow-up-m.38e0b0362896692347a6735322a0015d.svg";
export { ForwardRef as ReactComponent };